import { jsx as _jsx } from "react/jsx-runtime";
import Switch from "react-switch";
function Toggle({ checked, handleChange }) {
    return (_jsx(Switch, { onChange: handleChange, checked: checked, uncheckedIcon: false, checkedIcon: false, height: 20, width: 44 }));
}
export { Toggle };
